<template>
    <div class="shop-wrap page-inner">
        <ShopMenus />

        <Content v-if="page && page.donate_text && $route.params.slug === 'donate'" v-html="page.donate_text"></Content>

        <List v-if="$route.name === 'shop-category' && $route.params.slug === 'donate' && products.length !== 0">
            <DonateItem v-for="(item, index) in products" :key="item.id + '-' + index" :item="item" />
        </List>

        <List v-else-if="products.length !== 0">
            <Item v-for="(item, index) in products" :key="item.id + '-' + index" :item="item" />
        </List>
        
        <div class="load-more">
            <span v-if="!is_loading && !is_end" @click="getProducts()">Show more results +</span>
            <span v-if="is_loading && !is_end">Loading...</span>
        </div>

        <!-- is_loading -->
        <NoResults v-if="products.length === 0 && !is_loading && is_end">
            No products ...
        </NoResults>
        
        <Highlights v-if="$route.name === 'shop-category' && $route.params.slug === 'donate'" />
        <Global class="in-page" />
        <Collection v-if="$route.name === 'shop-category' && $route.params.slug === 'donate'" />

    </div>
</template>
<script>
import List from '@/components/ui/List.vue';
import Content from '@/components/ui/Content.vue';
import Item from '@/components/ProductItem.vue';
import DonateItem from '@/components/DonateItem.vue';
import NoResults from '@/components/ui/NoResults.vue';
import ShopMenus from '@/components/ShopMenus.vue';
import Global from '@/components/Global.vue';
import Highlights from '@/components/Highlights.vue';
import Collection from '@/components/Collection.vue';

export default {
    name: 'shop',

    data () {
        return {
            page: false,
            products: [],
            paged: 1,
            per_page: 12,
            is_end: false,
            is_loading: false
        }
    },

    components: {
        Content,
        List,
        Item,
        NoResults,
        ShopMenus,
        Global,
        Highlights,
        Collection,
        DonateItem,
    },

    watch: {
        '$route.params': {
            handler(params) {
                this.fetchData(params);
            },

            immediate: true,
        }
    },

    methods: {
       getProducts() {
            if (this.is_end) return;
            this.paged ++;
            

            this.is_loading = true;

            let url = `get-products?per_page=${this.per_page}&paged=${this.paged}`;
            if (this.$route.name === 'shop-category') {
                url = url + '&cat=' + this.$route.params.slug;
            }

            this.$ajax.get(url).then(res => {
                res.data.forEach(item => {
                    this.products.push(item);
                });
    
                
                this.is_loading = false;
                this.is_end = (res.data.length < this.per_page);
            }).catch((error) => {
                // console.log(error)
                this.is_end = true;

            });
        },

        fetchData(params) {
            console.log(params)
            this.paged = 0;
            this.products = [];
            this.is_end = false;
            this.page = false;
            this.is_loading = true;
            // this.current_page_id = false;

            this.sub_pages = [];
            this.$ajax.get('pages?slug=shop').then(res => {
                this.page = res.data[0];
                this.$store.state.is_loading = false;

                this.sub_pages.push({
                    post_title: 'MIMA Online Shop',
                    ID: res.data[0].id,
                    link: '/shop',
                });

                if (this.$route.name === 'shop-category') {
                    this.$ajax.get('/get-term/product_cat/' + params.slug).then(r => {
                        this.current_page_id = r.data.term_id;
                        this.title = this.$decode(r.data.name);
                        document.title = 'MIMA — ' + this.title;
                    });
                } else {
                    this.current_page_id = res.data[0].id;
                    this.title = this.$decode(res.data[0].title.rendered);
                    document.title = 'MIMA — ' + this.title;
                }
                

                this.$ajax.get('/product-categories').then(r => {
                    r.data.forEach(item => {
                        this.sub_pages.push(item);
                    });

                    this.$ajax.get('pages?slug=shipping-and-returns').then(res => {
                        res.data.forEach(item => {
                            item.ID = item.id;
                            item.is_page_item = true;
                            item.post_title = item.title.rendered;
                            this.sub_pages.push(item);
                        });
                    });
                });

                
            });

            this.is_end = false;
            this.getProducts();

        },

    },




}
</script>

<style lang="scss">

    .shop-wrap {
        .ui-enter {
            padding: 0 var(--padding) 0;

            h2 {
                margin-bottom: var(--padding-50);
            }
        }

        .ui-list {
            margin-top: var(--padding-50);
            padding: 0 var(--padding-50) var(--padding) var(--padding-50)
        }

        .load-more {
            text-align: center;
            padding: 0 var(--padding) var(--padding-x2);
            min-height: 3rem;

            span {
                cursor: pointer;
            }
        }
    }


</style>